export default __webpack_public_path__ + "static/media/draco.e337261b.png";